// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OB-z","videoWrapper":"PB-z","twoColumnImage":"QB-z","imageCarouselBtn":"RB-z","carouselNextBtn":"SB-z","carouselPrevBtn":"TB-z"};